import React from "react";
import Base64Encode from "../Base64Encode";
import { LeadFormTemplate, LeadFormTemplateProps } from "./LeadFormTemplate";

export const LeadFormEncodedTemplate: React.FC<LeadFormTemplateProps> = (props) => {
  const { salt } = props;

  return (
    <code id={`${salt}-lead-form-template`} style={{ display: "none" }} data-encoded="base64">
      <Base64Encode>
        <LeadFormTemplate {...props} />
      </Base64Encode>
    </code>
  );
};
